import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import { normalize } from "normalizr";
import { clientActivitiesSchema } from "./dashboard-squema";
import { SET_CLIENT_ACTIVITY, RESET_CLIENT_ACTIVITY } from "./dashboard-mutations";
import { getClientActivity } from "../api/dashboard-api";
import Err from "@Client/@Routes/error";
export const LOAD_CLIENT_ACTIVITY = "LOAD_CLIENT_ACTIVITY";
const actions = {
  [LOAD_CLIENT_ACTIVITY]: async (context, {
    applicationId,
    offset,
    limit
  }) => {
    try {
      var _clientActivity$;
      const clientActivity = await getClientActivity(applicationId, {
        offset,
        limit
      });
      const {
        entities,
        result
      } = normalize(clientActivity, [clientActivitiesSchema]);
      if (offset === 0) context.commit(RESET_CLIENT_ACTIVITY);
      context.commit(SET_CLIENT_ACTIVITY, {
        clients: {
          byId: entities.clientActivities || {},
          allIds: result
        }
      });
      const totalRecords = _parseInt((_clientActivity$ = clientActivity[0]) == null ? void 0 : _clientActivity$.total) || 0;
      const count = context.state.clientActivity.allIds.length;
      return count < totalRecords;
    } catch (e) {
      Err.handle(e);
    }
  }
};
export default actions;